import { put, takeLatest } from "redux-saga/effects";

import { EToastType } from "@/components/common/AlertToast/AlertToast.types";
import apiErrorHandler from "@/utils/apiErrorHandler";
import {
  GET_INTERVIEW_DETAILS_API_HTTP_STATUS_CODES,
  GET_INTERVIEW_DETAILS_ERROR_MESSAGE,
  GET_INTERVIEW_META_API_HTTP_STATUS_CODES,
  GET_INTERVIEW_META_ERROR_MESSAGE,
} from "@/constants/InterviewConstants";
import { HTTP_STATUS_CODES } from "@/constants/HttpConstants";
import { GET_INTERVIEW_DETAILS_API } from "@/constants/ApiNameConstants";
import {
  setApiCallInProgress,
  setApiCallSuccess,
  setApiCallError,
} from "@/actions/apiCallStatus.action";
import { showToast } from "../actions/appStatus.action";
import {
  getInterviewDetailAPI,
  getInterviewMetaAPI,
} from "../api/interview.api";
import {
  GET_INTERVIEW_DETAILS,
  GET_INTERVIEW_META,
} from "../constants/ActionTypes";
import {
  IGetInterviewDetailsAction,
  IGetInterviewMetaAction,
} from "../types/interview.types";
import { call } from "./utils.saga";

function* getInterviewDetails({ payload }: IGetInterviewDetailsAction) {
  try {
    yield put(setApiCallInProgress(GET_INTERVIEW_DETAILS_API));
    const { interviewSlug } = payload;
    const interviewDetailResp = yield* call(
      getInterviewDetailAPI,
      interviewSlug,
    );
    if (interviewDetailResp.status === HTTP_STATUS_CODES.OK) {
      yield put({
        type: `${GET_INTERVIEW_DETAILS}_SUCCESS`,
        payload: interviewDetailResp.data,
      });
      yield put(setApiCallSuccess(GET_INTERVIEW_DETAILS_API));
    }
  } catch (error: unknown) {
    yield put(setApiCallError(GET_INTERVIEW_DETAILS_API));
    const message = yield* call(
      apiErrorHandler,
      error,
      GET_INTERVIEW_DETAILS_API_HTTP_STATUS_CODES,
      GET_INTERVIEW_DETAILS_ERROR_MESSAGE,
    );
    if (message)
      yield put(
        showToast({
          message,
          type: EToastType.ERROR,
        }),
      );
  }
}

function* getInterviewMeta({ payload }: IGetInterviewMetaAction) {
  try {
    const { accessCode } = payload;
    const interviewMetaResponse = yield* call(getInterviewMetaAPI, accessCode);
    yield put({
      type: `${GET_INTERVIEW_META}_SUCCESS`,
      payload: { ...interviewMetaResponse.data, accessCode },
    });
  } catch (error: unknown) {
    const message = yield* call(
      apiErrorHandler,
      error,
      GET_INTERVIEW_META_API_HTTP_STATUS_CODES,
      GET_INTERVIEW_META_ERROR_MESSAGE,
    );
    if (message)
      yield put(
        showToast({
          message,
          type: EToastType.ERROR,
        }),
      );
  }
}

export default function* loadInterviewSaga() {
  yield takeLatest(GET_INTERVIEW_DETAILS, getInterviewDetails);
  yield takeLatest(GET_INTERVIEW_META, getInterviewMeta);
}
